<template>
    <div v-if="loaded">
        <div v-if="datasets.length + distributions.length > 0">
            <table v-if="datasets.length > 0" class="table table-striped" >
                <thead>
                    <tr>
                        <th colspan="2">Included Data Sets</th>
                    </tr>
                    <tr class="sticky-header">
                        <th>Name</th>
                        <th>Definition</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="ds in datasets" :key="ds.id">
                        <td>
                            <a :href="objectUrl + ds.id" target="_blank" title="Open data set in new tab">
                                {{ ds.name }}
                            </a>
                        </td>
                        <td>
                            <p v-html="ds.definition" />
                        </td>
                    </tr>
                </tbody>
            </table>

            <table v-if="distributions.length > 0" class="table table-striped" >
                <thead>
                    <tr>
                        <th colspan="2">Included Distributions</th>
                    </tr>
                    <tr class="sticky-header">
                        <th>Name</th>
                        <th>Definition</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="dist in distributions" :key="dist.id">
                        <td>
                            <a :href="objectUrl + dist.id" target="_blank" title="Open distribution in new tab">
                                {{ dist.name }}
                            </a>
                        </td>
                        <td>
                            <p v-html="dist.definition" />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <strong v-else> No items are included in this data set </strong>
    </div>
    <Loading v-else />
</template>

<script>
import Loading from 'src/components/Loading.vue'
import fetchUtils from 'src/components/dataset/fetchUtils.js'

export default {
    name: "DatasetDetails",
    components: {
        Loading
    },
    mixins: [fetchUtils],
    props: {
        id: {
            type: String,
            required: true
        }
    },
    data: () => ({
        loaded: false,
        datasets: [],
        distributions: [],
        objectUrl: '/item/'
    }),
    created: async function() {
        const root = await this.fetchDataset(this.id)
        this.getIncluded(root)
        this.removeDuplicates()

        this.loaded = true
    },
    methods: {
        getIncluded: function(group) {
            this.datasets = this.datasets.concat(group.datasets)
            this.distributions = this.distributions.concat(group.distributions)

            for (let subgroup of group.groups) {
                this.getIncluded(subgroup)
            }
        },
        removeDuplicates: function() {
            this.datasets = this.datasets.filter((ds1, i) => {
                // filter out all but the first occurance of the given id
                return this.datasets.findIndex(ds2 => ds2.uuid === ds1.uuid) === i
            })
            this.distributions = this.distributions.filter((dist1, i) => {
                return this.distributions.findIndex(dist2 => dist2.uuid === dist1.uuid) === i
            })
        }
    }
}
</script>

<style scoped>
table {
    border-collapse: separate;
    table-layout: fixed;
    width: 100%;
    overflow-wrap: break-word;
}

thead {
    position: sticky;
    top: 0;
    background: whitesmoke;
}

a {
    cursor: pointer;
}
</style>
